import React from 'react'
import { motion } from 'framer-motion'
import Header from '../components/Header'
import SearchSection from '../components/SearchSection'
import QuickNavigation from '../components/QuickNavigation'
import ResultsSection from '../components/ResultsSection'
import AboutSection from '../components/AboutSection'
import Footer from '../components/Footer'
import BackgroundEffects from '../components/BackgroundEffects'

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-pink-50 dark:from-gray-900 dark:via-gray-800 dark:to-purple-900">
      <BackgroundEffects />
      
      <div className="relative z-10">
        <Header />
        
        <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 space-y-8 max-w-6xl">
          <motion.section
            id="search-section"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 space-y-6"
          >
            <SearchSection />
            <QuickNavigation />
          </motion.section>
          
          <ResultsSection />
          <AboutSection />
        </main>
        
        <Footer />
      </div>
    </div>
  )
}

export default HomePage